import { ApplicationsApi } from "../../api/apis/RepresentationApplicationsApi";
import { UsersApi } from "../../api/apis/UsersApi";
import { CustomersApi } from "../../api/apis/CustomerApi";
import { authMiddleware } from "../../api/authMiddleware";
import { Configuration } from "../../api/runtime";
import { createOpenApiInstance } from "./createOpenApiInstance";
import { UserCustomerApi } from "../../api/apis/UserCustomerApi";
import { OrganizationsApi } from "../../api/apis/OrganizationsApi";

export interface ApiRegistry {
    applicationsApi: ApplicationsApi;
    usersApi: UsersApi;
    customersApi: CustomersApi;
    userCustomerApi: UserCustomerApi;
    organizationsApi:OrganizationsApi;
}

const apiRegistry: ApiRegistry = {
    applicationsApi: createOpenApiInstance<ApplicationsApi>(ApplicationsApi, new Configuration({middleware: [authMiddleware]})),
    usersApi: createOpenApiInstance<UsersApi>(UsersApi, new Configuration({middleware: [authMiddleware]})),
    customersApi: createOpenApiInstance<CustomersApi>(CustomersApi, new Configuration({ middleware: [authMiddleware] })),
    userCustomerApi: createOpenApiInstance<UserCustomerApi>(UserCustomerApi, new Configuration({middleware: [authMiddleware]})),
    organizationsApi: createOpenApiInstance<OrganizationsApi>(OrganizationsApi, new Configuration({middleware: [authMiddleware]}))
}

export function getApiRegistry() {
    return apiRegistry;
}